/** Relations that count as the employee's household partner (at most one). */
export const HOUSEHOLD_PARTNER_RELATIONS = ['spouse', 'pacs', 'cohabitant'] as const

export type HouseholdPartnerRelation = (typeof HOUSEHOLD_PARTNER_RELATIONS)[number]

export function isHouseholdPartnerRelation(relation: string): boolean {
  return (HOUSEHOLD_PARTNER_RELATIONS as readonly string[]).includes(relation)
}
